<div class='app-date-picker'>
  <input
    (focusout)='onFocusOut()'
    [id]='id'
    [ngClass]='{ "is-invalid": isInvalid() }'
    [disabled]='disabled'
    [(ngModel)]='value'
    type='text'
    mask="d0.m0.0000"
    [dropSpecialCharacters]="false"
    class='icon-calendar'
    [mode]="mode"
    [dpDayPicker]='calendarConfig'
    (ngModelChange)='onPickDate($event)'
    [placeholder]="placeholder">
</div>
